import * as angular from 'angular';

import { GroupService } from './group.service';

export const groupServiceModule = angular.module('groupService', [])
	.service('GroupService', GroupService)
	.name;
